module.exports = __webpack_public_path__ + "static/media/photo2-2.a651753a.png";